import { createAction, createSlice } from "@reduxjs/toolkit";

const getAllCourseLevelSlice = createSlice({
  name: "getAllCourseLevel",
  initialState: { data: null, success: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      const { data } = action.payload;
      state.data = data;
      state.success = true;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.success = false;
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getAllCourseLevelSlice;
const getAllCourseLevelAction = createAction(name);

export {
  getAllCourseLevelAction,
  actions as getAllCourseLevelActions,
  reducer as getAllCourseLevelReducer,
};
